export default {
    'one' : 'When at least one activity is uploaded',
    'never' : 'Always unlocked',
};
